/**
 * HelpAnchor — a small "?" icon that jumps to a Help Center article.
 *
 * Drop next to any page title. Clicking opens `/help#<articleId>` in a new
 * tab so the operator doesn't lose their working context.
 *
 *   <HelpAnchor articleId="serials" />
 *
 * `label` is optional and appears as a tooltip only.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Question } from '@phosphor-icons/react';

export default function HelpAnchor({ articleId, label, className = '' }) {
  if (!articleId) return null;
  const tooltip = label || 'Open the user manual for this page';
  return (
    <Link
      to={`/help#${articleId}`}
      target="_blank"
      rel="noopener noreferrer"
      title={tooltip}
      aria-label={tooltip}
      data-testid={`help-anchor-${articleId}`}
      className={`inline-flex items-center justify-center w-6 h-6 border border-brand/40 text-brand hover:bg-brand hover:text-white transition-colors ${className}`}
    >
      <Question size={14} weight="bold" />
    </Link>
  );
}
